export const CTT = 'CTT' as const;
export const LAUNCHPAD_BRANDING = 'LAUNCHPAD_BRANDING' as const;
export const LAUNCHPAD_KB_INTEGRATIONS = 'LAUNCHPAD_KB_INTEGRATIONS' as const;
export const LOCALIZATION_ACCESS = 'LOCALIZATION_ACCESS' as const;
export const PINS_ACCESS = 'PINS_ACCESS' as const;
